@import "tailwindcss/theme.css" layer(theme);
@import "tailwindcss/preflight.css" layer(base);
@import "tailwindcss/utilities.css";

@theme {
  --font-display: 'Lexend', 'sans-serif';
  --font-body: 'Lexend', 'sans-serif';
  --color-primary: #0B5FFF;
}

:root {
  font-family: 'Lexend', sans-serif;
  --color-primary: #0B5FFF;
}

/* Platform-specific font families */
@media android {
  :root {
    --font-mono: monospace;
    --font-rounded: normal;
    --font-serif: serif;
    --font-sans: normal;
  }
}

@media ios {
  :root {
    --font-mono: ui-monospace;
    --font-serif: ui-serif;
    --font-sans: system-ui;
    --font-rounded: ui-rounded;
  }
}